import { useDateAdapterUtils } from '../DatePickersUtils/useDateAdapterUtils';

export const useFormatDate = () => {
  const { format } = useDateAdapterUtils();

  const getFormattedPlaceholder = () => {
    return format(new Date());
  };

  return {
    getFormattedDate: format,
    getFormattedPlaceholder
  };
};
